export interface SponsorBenefit {
  title: string;
  description: string;
}

export const sponsorBenefits: SponsorBenefit[] = [
  {
    title: "A Practice-Level Differentiator",
    description: "Move beyond transactions. Deliver structured aging-at-home strategy your clients can feel and trust."
  },
  {
    title: "Retention Through Relevance", 
    description: "Stay embedded during life transitions that often reduce advisor visibility and engagement."
  },
  {
    title: "Proactive Leadership",
    description: "Show families you are thinking ahead, not reacting after a crisis."
  }
];
